import {ProductType} from "../api";

const bottledWineType = "BottledWine" as ProductType;

const productTypeTranslations: { type: ProductType, translation: string }[] = [
    { type: ProductType.Wine, translation: "Wino" },
    { type: bottledWineType, translation: "Wino zabutelkowane" },
    { type: ProductType.LabeledWine, translation: "Wino z etykietą" },
    { type: ProductType.Fruit, translation: "Owoce" },
    { type: ProductType.Juice, translation: "Sok" },
    { type: ProductType.Pomace, translation: "Wytłoki" },
    { type: ProductType.Sediment, translation: "Osad" },
    { type: ProductType.Bottle, translation: "Butelka" },
    { type: ProductType.Other, translation: "Inne" },
];

const productTypeTranslationsHelper = (type: ProductType) =>
    productTypeTranslations.find(x => x.type === type)?.translation ?? "";

export default productTypeTranslationsHelper;
